import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faUser } from "@fortawesome/free-solid-svg-icons";
import { useGetCollabList } from "../services/useGetCollabList";

const SendRecipientCard = ({
  recipient,
  index,
  remove,
  register,
  errors,
  watch,
  setValue,
}) => {
  const borderColors = [
    "bg-yellow-400",
    "bg-green-400",
    "bg-blue-400",
    "bg-indigo-400",
    "bg-purple-400",
    "bg-pink-400",
  ];

  const colorIndex = index % borderColors.length;
  const borderColorClass = borderColors[colorIndex];
  const { data: collabList } = useGetCollabList();

  const [documentType, setDocumentType] = useState("add_custom");

  return (
    <div className="bg-white rounded-lg shadow-sm p-4 mb-4 border border-gray-200 relative flex-1">
      <div
        className={`absolute left-0 top-0 bottom-0 w-1 rounded-l-lg ${borderColorClass}`}
      ></div>

      <div className="flex items-center justify-between mb-2">
        <span className="text-gray-700 text-sm font-semibold flex">
          {recipient.signer_role_name}
        </span>{" "}
        {/* <button
          type="button"
          onClick={() => remove(index)}
          className=" hover:bg-gray-200 text-red-400 font-bold py-1 px-2 rounded text-sm focus:outline-none"
        >
          <FontAwesomeIcon icon={faTrash} />
        </button> */}
      </div>

      <div className="mb-3">
        <select
          className="w-full bg-white border ring-1 rounded px-4 py-2 text-left text-sm focus:outline-none transition-all hover:bg-gray-100"
          value={documentType}
          onChange={(e) => {
            setDocumentType(e.target.value);
            setValue(`recipients[${index}].collab_id`, "");
            setValue(`recipients[${index}].name`, "");
            setValue(`recipients[${index}].email`, "");
          }}
        >
          <option value="add_custom">Add Custom</option>
          <option value="select_prefilled_data">Select Prefilled Data</option>
        </select>
      </div>

      {documentType === "select_prefilled_data" && (
        <div className="mb-3">
          <label
            htmlFor={`recipients[${index}].collab_id`}
            className="block text-gray-700 text-sm font-bold mb-2"
          >
            Select Collab Physician:
          </label>
          <select
            className="shadow border ring-1 rounded w-full py-2 px-3 text-gray-700 focus:ring-2 focus:ring-[#cfc9ff]"
            onChange={(e) => {
              const [id, name, email] = e?.target?.value?.split("-");
              setValue(`recipients[${index}].collab_id`, Number(id));
              setValue(`recipients[${index}].name`, name);
              setValue(`recipients[${index}].email`, email);
              setValue(`recipients[${index}].signer_role_id`, Number(id));
              setValue(`recipients[${index}].signer_role_name`, "collab-phys");
              setValue(`recipients[${index}].signer_roles`, 3);
            }}
          >
            <option value="">Select Collab</option>
            {collabList?.db_collab_list?.map((collab) => (
              <option
                value={`${collab.id}-${collab.full_name}-${collab.email}`}
              >
                {collab.full_name}
              </option>
            ))}
          </select>
        </div>
      )}

      <div className="mb-3">
        <label
          htmlFor={`recipients[${index}].name`}
          className="block text-gray-700 text-sm font-bold mb-2"
        >
          Name:
        </label>
        <div className="relative">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <FontAwesomeIcon icon={faUser} className="text-gray-500" />
          </div>
          <input
            type="text"
            {...register(`recipients[${index}].name`, {
              required: "Name is required",
            })}
            className="shadow appearance-none border ring-1 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:ring-2 focus:ring-[#cfc9ff] pl-10"
          />
        </div>
        {errors.recipients?.[index]?.name && (
          <p className="text-red-500 text-xs italic">
            {errors.recipients[index].name.message}
          </p>
        )}
      </div>

      <div>
        <label
          htmlFor={`recipients[${index}].email`}
          className="block text-gray-700 text-sm font-bold mb-2"
        >
          Email:
        </label>
        <input
          type="email"
          {...register(`recipients[${index}].email`, {
            required: "Email is required",
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: "Invalid email address",
            },
          })}
          className="shadow appearance-none border ring-1 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:ring-2 focus:ring-[#cfc9ff]"
        />
        {errors.recipients?.[index]?.email && (
          <p className="text-red-500 text-xs italic">
            {errors.recipients[index].email.message}
          </p>
        )}
      </div>
    </div>
  );
};

export default SendRecipientCard;
